// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useEffect, useMemo, useState} from 'react';
import cn from 'classnames';
import styles from './slider.module.less';

interface i_slide {
    id: string,
    content?: (p:object_of<any>)=>JSX.Element;
}
export interface i_slider_props {
    items: i_slide[];
    cls?: string;
    active: string;
    timeout: number;
    cmp_props: object_of<any>;
    on_end_animation?: ()=>void;
    distance: number;
    vertical?: boolean;
}
export const Slider = (props:i_slider_props)=>{
    const [state, set_state] = useState({active: props.active, next: '',
        animation: 0});
    useEffect(()=>{
        if (props.active!=state.active)
            set_state(v=>({...v, next: props.active, animation: 0}));
    }, [props.active]);
    useEffect(()=>{
        let timeout;
        if (!state.next)
            return;
        if (state.animation==0)
        {
            timeout = setTimeout(()=>{
                set_state(v=>({...v, animation: 1}));
            }, 100);
        }
        else if (state.animation==1)
        {
            timeout = setTimeout(()=>{
                set_state(v=>({...v, next: props.active, animation: 2}));
            }, props.timeout);
        }
        else if (state.animation==2)
        {
            timeout = setTimeout(()=>{
                set_state(v=>({...v, next: props.active, animation: 3}));
            }, 100);
        }
        else
        {
            timeout = setTimeout(()=>{
                set_state({active: props.active, next: '', animation: 0});
                if (props.on_end_animation)
                    props.on_end_animation();
            }, props.timeout);
        }
        return ()=>clearTimeout(timeout);
    }, [state.next, state.active, state.animation]);

    const style:object_of<string> = useMemo(()=>({
        '--animation_duration': `${props.timeout}ms`,
        '--animation_distance': `${props.distance||100}%`,
        '--animation_distance_m': `-${props.distance||100}%`,
    }), [props.timeout]);
    const next_index = props.items.findIndex(item=>item.id==state.next);
    const current_index = props.items.findIndex(item=>item.id==state.active);
    const direction_cl = next_index>-1 ? cn(current_index<next_index ?
        styles.forward : styles.backward) : '';
    return <div className={cn(direction_cl, styles.slider,
      props.vertical && styles.vertical)} style={style}>
      {props.items.map(item=>{
          const item_cl = cn(
              state.active==item.id && !state.next && styles.slide_enter_done,
              state.active==item.id && state.next && !state.animation
                  && styles.slide_exit,
              state.active==item.id && state.next && state.animation==1
                  && styles.slide_exit_active,
              state.active==item.id && state.next && state.animation>1
                  && styles.slide_exit_done,
              state.next==item.id && state.animation<2
                  && styles.slide_exit_done,
              state.next==item.id && state.animation==2 && styles.slide_enter,
              state.next==item.id && state.animation==3
                  && styles.slide_enter_active,
              state.next!=item.id && state.active!=item.id
                  && styles.slide_exit_done,
          );
          const Content = item.content;
          if (Content)
          {
              return <Content cls={item_cl} key={item.id}
                cmp_props={props.cmp_props}/>;
          }
          return null;
      })}
    </div>;
};
